import { render, staticRenderFns } from "./WeekdayContent.vue?vue&type=template&id=97f362fa"
import script from "./WeekdayContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./WeekdayContent.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports